import PropTypes from 'prop-types';
import React from 'react';
import ResourceProperty from '../../../common/resource/ResourceProperty';
import { tzNormalizeDate } from '../../../../utils/date';
import { FULL_DATE_TIME_FORMAT } from '../../../../config/locale';
import LinkToModuleResource from '../../../common/resource/LinkToModuleResource';
import { CARGO_CORPORATE_CREDIT_PATH } from '../../../../config/paths';

const ParcelPriceConfigurationBasicInformationResource = ({
  id,
  basePrice,
  maxEnvelopeWeight,
  envelopeLength,
  envelopeWidth,
  envelopeHeight,
  volumetricDivisor,
  createDate,
  lastUpdate,
  cargoCorporateCredit,
  yangoFirstKilometerPrice,
  deliveryKilometerPrice,
}) => (
  <>
    <ResourceProperty label="ID:">{id}</ResourceProperty>
    <ResourceProperty label="Precio Base:">{basePrice}</ResourceProperty>
    <ResourceProperty label="Peso Máximo de Sobre:">
      {maxEnvelopeWeight}
    </ResourceProperty>
    <ResourceProperty label="Altura de Sobre:">
      {envelopeHeight}
    </ResourceProperty>
    <ResourceProperty label="Longitud de Sobre:">
      {envelopeLength}
    </ResourceProperty>
    <ResourceProperty label="Ancho de Sobre:">{envelopeWidth}</ResourceProperty>
    <ResourceProperty label="Divisor Volumétrico:">
      {volumetricDivisor}
    </ResourceProperty>
    <ResourceProperty label="Crédito Corporativo:">
      {cargoCorporateCredit ? (
        <LinkToModuleResource
          text={cargoCorporateCredit.name}
          href={`${CARGO_CORPORATE_CREDIT_PATH}/${cargoCorporateCredit.id}`}
          isExternalPath
        />
      ) : (
        '-'
      )}
    </ResourceProperty>
    <h3>Datos de Reparto</h3>
    <ResourceProperty label="Precio por Kilómetro:">
      {deliveryKilometerPrice}
    </ResourceProperty>
    <ResourceProperty label="Precio Kilómetro Base (Yango):">
      {yangoFirstKilometerPrice}
    </ResourceProperty>
    <h3>Información Interna</h3>
    <ResourceProperty label="Fecha de Creación:">
      {tzNormalizeDate({ date: createDate, format: FULL_DATE_TIME_FORMAT })}
    </ResourceProperty>
    <ResourceProperty label="Última Actualización:">
      {tzNormalizeDate({ date: lastUpdate, format: FULL_DATE_TIME_FORMAT })}
    </ResourceProperty>
  </>
);

ParcelPriceConfigurationBasicInformationResource.propTypes = {
  id: PropTypes.number.isRequired,
  basePrice: PropTypes.number.isRequired,
  maxEnvelopeWeight: PropTypes.number.isRequired,
  envelopeLength: PropTypes.number.isRequired,
  envelopeWidth: PropTypes.number.isRequired,
  envelopeHeight: PropTypes.number.isRequired,
  volumetricDivisor: PropTypes.number.isRequired,
  cargoCorporateCredit: PropTypes.shape({
    name: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
  }),
  yangoFirstKilometerPrice: PropTypes.number,
  deliveryKilometerPrice: PropTypes.number,
  createDate: PropTypes.number.isRequired,
  lastUpdate: PropTypes.number.isRequired,
};

ParcelPriceConfigurationBasicInformationResource.defaultProps = {
  cargoCorporateCredit: null,
  yangoFirstKilometerPrice: 0,
  deliveryKilometerPrice: 0,
};

export default ParcelPriceConfigurationBasicInformationResource;
